import locale from 'antd/es/locale/nl_NL';
import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/nl';
import { createRoot } from 'react-dom/client';
import './index.css';
import ReactApp from './app';
import theme from './theme';
dayjs.extend(customParseFormat);
dayjs.locale('nl');
const container = document.getElementById('root');
if (!container) throw new Error('Root element ontbreekt.');
const root = createRoot(container);
root.render(
  <ConfigProvider locale={locale} theme={theme} inputNumber={{ styles: { actions: { display: 'none' } } }}>
    <ReactApp />
  </ConfigProvider>
);
